import { ReactNode, useEffect, useRef, useState } from "react";

function PinInput({onChange}) {
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const inputRef = useRef();
  const inputRefWrap = useRef();

  const inputRef1 = useRef();
  const inputRef2 = useRef();
  const inputRef3 = useRef();
  const inputRef4 = useRef();
  const inputRef5 = useRef();
  const inputRef6 = useRef();

  const inputRefs = [inputRef1, inputRef2, inputRef3, inputRef4, inputRef5, inputRef6];

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (isNaN(value)) {
      return;
    }

    if (e.key === undefined) {
      const newPin = [...pin];
      newPin[index] = value.slice(0, 1);
      setPin(newPin);

      const joinedPin = newPin.join("");

      if (index <= 4 && e.key !== "Backspace") {
        inputRefs[index].current?.blur();
      }

      if (index <= 4 && e.key !== "Backspace") {
        inputRefs[index + 1].current?.focus();
      }

      onChange(joinedPin);
    }
  };

  const handleChange = (event) => {
    // const value = event.target.value;
    // setPin(value);
    // setPin(newPin);
    // if (value.length === 4) {
    //   inputRef?.current?.blur();
    // }
  };

  const handleKeyDown = (e, index) => {
    // if (e.key === "Backspace" && index > 0) {
    //     alert("jmm");
    // const newPin = [...pin];
    // newPin[index - 1] = "";
    // setPin(newPin);
    // }

    if (e.key === "Backspace" && index <= 5) {
      if (inputRefs[index].current.value === "") {
        // alert('yapp')
        // const newPin = [...pin];
        // newPin[index] = "";
        // setPin(newPin);

        inputRefs[index - 1].current.focus();
        inputRefs[index].current.blur();
      }
    }
  };

  return (
    <div className="pin-input gap-x-6" ref={inputRefWrap}>
      {pin.map((value, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={value}
          className="border w-12 text-center rounded-md h-10"
          onChange={(e) => handleInputChange(e, index)}
          // onChange={(e) => handleChange(e)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={inputRefs[index]}
        />
      ))}
    </div>
  );
}

export default PinInput;
